import { IListResource } from './Resource';
import { ServerService } from '../services/ServerService';
import { IListFetcher } from '../fetchers/IListFetcher';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { ResourceQuery } from './ResourceQuery';
import { GetDatabasesRequest } from '../ServerApi/requests/GetDatabasesRequest';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { Module } from '../Module';
import { IDatabaseInfo } from '../models/IDatabaseInfo';


export class DatabasesWithCrass implements IListResource<IDatabaseInfo> {

  public static ServiceLocatorKey = 'DatabasesWithCrass';

  public static $inject = [
    'ErrorNotifyingServer',
    'FetcherFactory'
  ];

  private listFetcher: IListFetcher<IDatabaseInfo>;
  private allQuery: ResourceQuery<IDatabaseInfo>;

  constructor(
    ErrorNotifyingServer: ErrorNotifyingServer,
    FetcherFactory: FetcherFactory
  ) {
    this.listFetcher = FetcherFactory.getServerResourceFetcher(GetDatabasesRequest, ServerApiMapper.databasesUsingCrass);
    this.allQuery = new ResourceQuery(this.listFetcher);
  }

  public all(): ResourceQuery<IDatabaseInfo> {
    return this.allQuery;
  }

}

Module.instance().service('DatabasesWithCrass', DatabasesWithCrass);
